import { Model, ModelData } from '../general'

export interface Data extends ModelData {
  name: string
  article_number: string
  image_file: string
}

class ProductType extends Model<Data> {
  get name() {
    return this.data.name
  }

  get articleNumber() {
    return this.data.article_number
  }

  get imageUrl() {
    return this.data.image_file
  }
}

export default ProductType
